import type { IRemoveViewMicro, IRunPlan } from '../types';
import { RemoteView } from './remote_view';
import { writeJSON } from '../services/json';

/**
 * load a micro application
 */
export class MicroRemoteView extends RemoteView {
  public runPlan: IRunPlan<IRemoveViewMicro>;

  async writeHead() {
    const runPlan = this.runPlan;
    const head = [...this._writeStandardHeader(runPlan)].join('\n');

    return head;
  }

  async writeBody() {
    return `<main id="app-remote-view"></main>`;
  }

  async writeIndex(runPlan: IRunPlan, head: string, body: string) {
    return `<!DOCTYPE html>
    <html lang="en">
      <head>${head}</head>
      <body>${body}</body>
    </html>`;
  }

  protected _computeStartupRemoteView<E extends HTMLElement>(computationalContext: E) {
    const runPlan = this.runPlan;
    const remoteView = runPlan.remote_view ?? ({} as IRemoveViewMicro);

    const microURI = remoteView.uri;
    const indexFile = remoteView.index_file;
    const initialHRF = remoteView.initial_href;
    const microOptions = writeJSON(remoteView.micro_options);

    return `
      hiReady(async () => {
        const [micro] = await $ip.requires(['${microURI}/${indexFile}', '${microURI}/index.css'])
        const appEl = document.querySelector('#app-remote-view');
        const microOptions = ${microOptions};
        const initialHash = '${initialHRF}';

        // register global micro for portal
        //
        document.body.__portal = document.body.__portal ?? {};
        document.body.__portal.artifacts = document.body.__portal.artifacts ?? {};
        document.body.__portal.artifacts['${microURI}'] = micro;

        // if micro is started, then first shutdown (from Ignition)
        //
        if (micro.started) {
          await micro.shutdown();
        }

        await micro.startup(appEl, microOptions);

        if (initialHash && location.href.indexOf('#') <= 0) {
          location.hash = initialHash;
        };
      });
    `;
  }
}
